import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgLargeHome = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 68 68", size: size }, props),
        React.createElement("path", { fill: "currentColor", d: "M55.3 41.3v16.1c0 2.3-1.9 4.3-4.3 4.3h-8.5c-1.2 0-2.1-1-2.1-2.1V46.8c0-3.5-2.9-6.4-6.4-6.4-3.5 0-6.4 2.9-6.4 6.4v12.8c0 1.2-1 2.1-2.1 2.1H17c-2.3 0-4.3-1.9-4.3-4.3V41.2c0-.6.2-1.1.6-1.5l19.1-19.1c.8-.8 2.2-.8 3 0l19.1 19.2c.6.4.8.9.8 1.5z" }),
        React.createElement("path", { fill: "currentColor", d: "M59.6 37.9c-.5 0-1.1-.2-1.5-.6L34 13.3l-24 24c-.8.8-2.2.8-3 0-.8-.8-.8-2.2 0-3L32.5 8.7c.4-.4.9-.6 1.5-.6s1.1.2 1.5.6l25.6 25.6c.8.8.8 2.2 0 3-.4.4-1 .6-1.5.6z" })));
};
export default SvgLargeHome;
//# sourceMappingURL=LargeHome.js.map